import { render, staticRenderFns } from "./GroupDatatable.vue?vue&type=template&id=b4dd2308&scoped=true&"
import script from "./GroupDatatable.vue?vue&type=script&lang=js&"
export * from "./GroupDatatable.vue?vue&type=script&lang=js&"
import style0 from "./GroupDatatable.vue?vue&type=style&index=0&id=b4dd2308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dd2308",
  null
  
)

export default component.exports